module.exports = __webpack_public_path__ + "static/index-hero-using-cloud-apps-dd4d51e8d43e84f2798a3bc5c72a9af7.svg";